/**
 * The motion scale, mirroring src/scss/abstracts/_variables.scss.
 *
 * Anything animated in JavaScript reads its timing from here, so a fold driven
 * by the Web Animations API moves exactly like a drop-down driven by a CSS
 * transition — one feel across the site, changed in two files at most.
 */

export const DURATION = {
  /** Hover, colour, focus — barely noticed. */
  fast: 200,
  /** Folds, drop-downs, crossfades — one thing replacing another. */
  base: 320,
  /** Entrances on scroll — something arriving from outside the screen. */
  slow: 800,
  /** A long move, where the distance itself needs the time. */
  travel: 1200,
};

/**
 * Steps between neighbours in a sequence. Mirrors $stagger-step in
 * _variables.scss, which is the CSS half of the same idea: anything arriving
 * one after another — menu items, cards, list rows, words of a heading — moves
 * on one of these, so the whole site keeps one rhythm.
 */
export const STAGGER = {
  /** Between two elements of a sequence. */
  element: 140,
  /** Between rows of a grid or list. */
  row: 110,
  /** Between words of a heading. */
  word: 70,
};

/** Entering motion decelerates. */
export const EASE_OUT = 'cubic-bezier(0.22, 1, 0.36, 1)';

/** Anything that goes back and forth eases both ends. */
export const EASE_IN_OUT = 'cubic-bezier(0.65, 0, 0.35, 1)';

/** A visitor who asked for less motion gets state changes without the travel. */
export const reducedMotion = (): boolean =>
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;
